import { render, staticRenderFns } from "./Waiyu.vue?vue&type=template&id=18921974&scoped=true&"
import script from "./Waiyu.vue?vue&type=script&lang=js&"
export * from "./Waiyu.vue?vue&type=script&lang=js&"
import style0 from "./Waiyu.vue?vue&type=style&index=0&id=18921974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18921974",
  null
  
)

export default component.exports